
/**
 * 时间秒数格式化
 * @param s 时间戳（单位：秒）
 * @param e 是否简洁模式，
 * @returns {*} 格式化后的时分秒
 */
export const sec2Time = (s, e = true) => {

    var t;
    if (s > -1) {
        var hour = Math.floor(s / 3600);
        var min = Math.floor(s / 60) % 60;
        var sec = s % 60;
        var comps = [];
        if (hour > 0 || !e) {
            if (hour < 10) {
                comps.push('0' + hour);
            } else {
                comps.push(hour);
            }
        }

        if (min < 10) { 
            comps.push('0' + min);
        } else {
            comps.push(min);
        }

        if (sec < 10) {
            comps.push('0' + sec);
        } else {
            comps.push(sec);
        }

        t = comps.join(":");
    }
    return t;
}

/**
 * 剪切字符串左右空白字符
 * @param {*} str 
 * @param {*} char 
 * @param {*} type 
 */
export const trim = (str, char, type) => {
     
    if (char) {
        if (type == 'left') {
            return str.replace(new RegExp('^\\' + char + '+', 'g'), '');
        } else if (type == 'right') {
            return str.replace(new RegExp('\\' + char + '+$', 'g'), '');
        }
        return str.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');
    }
    
    return str.replace(/^\s+|\s+$/g, '');
}

/**
 * 判断字符串为空
 * @param {*} obj 
 */
export const isEmpty = (obj) => {
    if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
    } else {
        return false;
    }
}

/**
 * 路径合并函数
 * @param {*} comps 
 */
export const R = (comps) => {

    switch (comps.length) {
        case 0:
            return "";
        case 1:
            return comps[0];
        default: {
            var path = [comps[0]];
            for (let index = 1; index < comps.length; index++) {
                var c = trim(comps[index], "/");
                path.push(c);
            }
            return path.join("/");
        }
    }
}

/**
 * 获取token
 */
export const getToken = () => {
    return localStorage.getItem('x-token');
}

/**
 * 设置token
 * @param {*} value 新token
 */
export const setToken = (value) => {

    if ( value != null ) {
        localStorage.setItem('x-token', value);
        return;
    }

    localStorage.removeItem('x-token');
}

/**
 * 获取code
 */
export const getCode = () => {
    return localStorage.getItem('x-code');
}

/**
 * 设置code
 * @param {*} value 新token
 */
export const setCode = (value) => {

    if ( value != null ) {
        localStorage.setItem('x-code', value);
        return;
    }

    localStorage.removeItem('x-code');
}

/**
 * 当前手机是否为安卓
 */
export const isAndroid = () => {
    var u = navigator.userAgent;
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
}

export const isiOS = () => {
    var u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
}

export const isDebugger = () => {
    var u = navigator.userAgent;
    return u.indexOf('webdebugger') > -1; //微信开发者工具
}